import axios from 'axios'

import * as config from '@/config.json'

export default async function callInvoicesApi(params) {
  const url = `${ config.default.urlBaseFdv }/invoices/search`

  return axios({
      url: url,
      method: 'get',
      params: params,
      headers: { 'authorization': `${ config.default.authorizationToken }` }
    })
    .catch(error => console.error({ errorMessage: `[call-api|invoices|callInvoicesApi] ${ error }` }))
}

export async function callHistoryDetailsApi(invoiceId, cnpj) {
  const url = `${ config.default.urlBaseFdv }/invoices/${ invoiceId }/details/company/${ cnpj }`

  return axios({
      url: url,
      method: 'get',
      headers: { 'authorization': `${ config.default.authorizationToken }` }
    })
    .catch(error => console.error({ errorMessage: `[call-api|invoices|callHistoryDetailsApi] ${ error }` }))
}